import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorhandeneVwgValidationPayload,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';

export function* handleVhvNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    VhvActions.HANDLE_VHV_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleVhvNavigationToAngebot, App.VHV),
  );
}

export function* handleVhvNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();
  if (state.risikoort.isImmobilieImAusland) {
    yield put(new VhvActions().cleanAddressForAuslandstarifierung());
  }

  yield call(
    globalPut.put,
    globalActions.requestMultiangebotAdressValidation({
      appId: App.VHV,
      angebotsId: state.angebotsId,
      risikoort: state.risikoort,
    }),
  );
  const addressValidationAction = yield take(GlobalActions.PROVIDE_MULTIANGEBOT_ADRESS_VALIDATION);
  const {
    validationResult: addressValidationError,
    appId: addressAppId,
    angebotsId: addressAngebotsId,
  }: ProvideVorhandeneVwgValidationPayload = addressValidationAction.payload;

  if (!(addressAppId === App.VHV && addressAngebotsId === state.angebotsId && addressValidationError == null)) {
    return;
  }

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.VHV,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationError,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (!(contractAppId === App.VHV && contractAngebotsId === state.angebotsId && contractValidationError == null)) {
    return;
  }

  const vhvActions = new VhvActions();
  yield put(vhvActions.quoteDBRequested());
  yield put(vhvActions.zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.VHV,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
